module.exports = __webpack_public_path__ + "static/media/process-blue.bb4cb421.svg";